module.exports = __webpack_public_path__ + "static/media/account-plus-outline.99dd3779.svg";